import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { hideHeader, hideLogoAndFooter, changeBgColor } from "../../../actions/appStatus.actions";
import {
  callBeginCardControlsSession,
  callCardControlsGetCardList,
  callSaveCardStatus,
  callCancelExistingTravel,
  resetCardControlFlow,
  callPinUpdate,
  callPinValidation,
  setTravelExemptionEligibility,
} from "../../../actions/cardControls.actions";
import { CardControlsCard } from "../card/card-controls-card.component";
import CardControlsModal from "../modal/card-controls-modal.component";
import ResetPinFlow from "../flow-components/reset-pin-flow.component";
import ReplaceCardFlow from "../flow-components/replace-card-flow.component";
import { popupMenuOptions } from "./data/popupMenuOptions";
import Show from "../../../utils/show.component";
import { clearMfa } from "../../../actions/mfa.actions";
import { destroy } from "redux-form";
import { AuthPaymentErrorPage } from "../../authenticated-payments/error-page/auth-payment-error-page.component";
import CardControlsIneligibilityPage from "../ineligibility-page/card-controls-ineligibility-page.component";
import TravelAbroadExemptionFlow from "../flow-components/travel-abroad-exemption-flow.component";

const CardControlsParentComponent = (props) => {
  const initialModalState = {
    show: false,
    type: null,
  };
  const initialCardState = {
    type: null,
    maskedNumber: null,
    agreeNbr: null,
    cardHoldersName: null,
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [modalState, setModalState] = useState(initialModalState);
  const [processStep, setProcessStep] = useState(0);
  const [cardInfo, setCardInfo] = useState(initialCardState);

  useEffect(() => {
    props.hideLogoAndFooter();
    props.hideHeader();
    props.changeBgColor("#fcfdfe");
  }, []);

  const showCardControlsModal = (
    show,
    optionType,
    agreeNbr,
    cardType,
    IsActive,
    cardNumberLastFour,
    callCancelExistingTravel,
    existingTravel,
    advanceToCompleteStep,
    travelReasonSelected,
    showCloseIcon
  ) => {
    setModalState({
      show: show,
      optionType: optionType,
      agreeNbr: agreeNbr,
      cardType: cardType,
      IsActive: IsActive,
      cardNumberLastFour: cardNumberLastFour,
      callCancelExistingTravel: callCancelExistingTravel,
      existingTravel: existingTravel,
      advanceToCompleteStep: advanceToCompleteStep,
      travelReasonSelected: travelReasonSelected,
      showCloseIcon: showCloseIcon !== false,
    });
  };

  const saveCardStatus = (agreeNbr, cardType, isActive, cardNumberLastFour) => {
    props.callSaveCardStatus({
      AgreeNumber: agreeNbr,
      CardType: cardType,
      IsCardTurnOff: isActive,
      CardNumberLastFour: cardNumberLastFour,
    });
  };

  useEffect(() => {
    // Destroy all form state and payment info if we are at the initial step
    if (processStep === 0) {
      props.clearMfa();
      props.resetCardControlFlow();

      setCardInfo(initialCardState);
      setModalState(initialModalState);

      // Destroy all form state
      Object.keys(props.form).forEach((form) => {
        props.destroy(form);
      });

      props.callCardControlsGetCardList();
    }
  }, [processStep]);

  const backToCards = () => {
    window.scrollTo(0, 0);
    props.resetCardControlFlow();
    setProcessStep(0);
    setCardInfo(initialCardState);
  };

  const cardStateConstructor = () => {
    const stateObject = {};
    props.cardControls.cards.forEach((card) => {
      stateObject[card.CardNumberLastFour] = { showPopupMenu: false };
    });

    return stateObject;
  };

  const [cardStateController, setCardStateController] = useState(cardStateConstructor());

  const closeAllPopupMenus = () => {
    setCardStateController(cardStateConstructor());
  };

  const generateSingleCardToggle = (maskedNumber) => {
    return () => {
      setCardStateController((state) => {
        return {
          ...cardStateConstructor(),
          [maskedNumber]: { showPopupMenu: !state[maskedNumber].showPopupMenu },
        };
      });
    };
  };

  useEffect(() => {
    if (props.cardControls.cards.length > 0 && cardInfo.agreeNbr !== null) {
      // add cardholder to the card info object from the card list
      // doing it here so we don't have to pass that info through all the popup button components
      var cardListCard = props.cardControls.cards.find((c) => c.AgreeNbr === cardInfo.agreeNbr);
      cardInfo.cardHoldersName = cardListCard.CardHoldersName;
    }

    setCardStateController(cardStateConstructor());

    // show an invalid modal for these
    let invalidPopupTypes = [
      popupMenuOptions.invalid.CardStatusInvalid,
      popupMenuOptions.invalid.ReplaceCardSuspiciousActivity,
      popupMenuOptions.invalid.IneligibleReplaceCard,
    ];
    if (invalidPopupTypes.includes(cardInfo.type)) {
      showCardControlsModal(true, cardInfo.type);
    }

    // these options have a flow component, so set the process step
    let flowComponentTypes = [
      popupMenuOptions.valid.ResetPIN,
      popupMenuOptions.valid.ReplaceCard,
      popupMenuOptions.other.EligibleTravelExemption,
    ];
    if (flowComponentTypes.includes(cardInfo.type)) {
      setProcessStep(1);
    }
  }, [props.cardControls.cards, cardInfo]);

  const mapCards = (cardsArray) => {
    const mappedCards = cardsArray.map((card) => {
      return (
        <div style={{ marginBottom: "-15px" }} key={card.CardNumberLastFour}>
          <CardControlsCard
            {...card}
            windowWidth={windowWidth}
            showCardControlsModal={showCardControlsModal}
            setCardInfo={setCardInfo}
            cardState={cardStateController[card.CardNumberLastFour] || {}}
            togglePopupMenu={generateSingleCardToggle(card.CardNumberLastFour)}
            closeAllPopupMenus={closeAllPopupMenus}
          />
        </div>
      );
    });

    return mappedCards;
  };

  // Determines which component to display depending on which
  // flow is selected
  const determineComponent = (cardInfo) => {
    if (cardInfo.type === popupMenuOptions.valid.ResetPIN) {
      return ResetPinFlow;
    }
    if (cardInfo.type === popupMenuOptions.valid.ReplaceCard) {
      return ReplaceCardFlow;
    }
    if (cardInfo.type === popupMenuOptions.other.EligibleTravelExemption) {
      return TravelAbroadExemptionFlow;
    }
  };

  const SelectedFlowComponent = determineComponent(cardInfo);

  const getRender = () => {
    if (props.authPayment.hasError) {
      return <AuthPaymentErrorPage />;
    }
    if (props.cardControls.cards.length !== 0 && props.cardControls.cardsLoaded === true) {
      return (
        <div>
          <CardControlsModal
            {...modalState}
            hideModal={() => setModalState(initialModalState)}
            callSaveCardStatus={(agreeNbr, cardType, isActive, cardNumberLastFour) =>
              saveCardStatus(agreeNbr, cardType, isActive, cardNumberLastFour)
            }
            cardInfo={cardInfo}
            setCardInfo={setCardInfo}
            setTravelExemptionEligibility={props.setTravelExemptionEligibility}
          />
          <Show condition={processStep === 0}>
            <Show condition={!window.ReactNativeWebView}>
              <h2 className="bolder text-center my-5">Manage Debit Cards</h2>
            </Show>
            {/* Keep some margin if this is in webview since we omit the header */}
            <Show condition={window.ReactNativeWebView}>
              <div className="pb-3" />
            </Show>
            <div className="px-2 m-auto" data-e2e-id="cardListContainer">
              {" "}
              {mapCards(props.cardControls.cards)}
            </div>
          </Show>
          <Show condition={processStep !== 0}>
            <SelectedFlowComponent
              cardInfo={cardInfo}
              cardControls={props.cardControls}
              setProcessStep={setProcessStep}
              processStep={processStep}
              backToCards={backToCards}
              showCardControlsModal={showCardControlsModal}
              callCancelExistingTravel={callCancelExistingTravel}
              popupMenuOptions={popupMenuOptions}
              {...props}
            />
          </Show>
        </div>
      );
    } else if (props.cardControls.cards.length === 0 && props.cardControls.cardsLoaded === true) {
      return <CardControlsIneligibilityPage />;
    } else {
      return null;
    }
  };

  return getRender();
};

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  clearMfa,
  destroy,
  hideHeader,
  changeBgColor,
  hideLogoAndFooter,
  callBeginCardControlsSession,
  callCardControlsGetCardList,
  callSaveCardStatus,
  callCancelExistingTravel,
  resetCardControlFlow,
  callPinUpdate,
  callPinValidation,
  setTravelExemptionEligibility,
};

//Connect to Redux store
const CardControlsParent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CardControlsParentComponent)
);

export default CardControlsParent;



// WEBPACK FOOTER //
// ./src/components/card-controls/parent/card-controls-parent.component.js